import { useEffect, useState } from "react";

export default function ImageUpload({
  label = "Upload Poster",
  required = false,
  error,
  className = "",
  onChange,
  initialImage = null,
  disabled = false,
  id = "image-upload",
  name = "image",
  children
}) {
  const [preview, setPreview] = useState(initialImage);

  useEffect(() => {
    setPreview(initialImage);
  }, [initialImage]);

  useEffect(() => {
    return () => {
      if (preview?.startsWith("blob:")) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  const handleChange = (event) => {
    const file = event.target.files?.[0];

    if (!file || !file.type.startsWith("image/")) {
      return;
    }

    const imageUrl = URL.createObjectURL(file);

    setPreview(imageUrl);
    onChange?.(file);
  };

  return (
    <div className={`flex flex-col ${className}`}>
      <label
        htmlFor={id}
        className={`
          group relative flex min-h-0 flex-1 items-center justify-center
          overflow-visible border border-b-4 border-gray-300
          bg-white
          ${!preview ? "aspect-[2/3]" : ""}
          ${
            disabled
              ? "cursor-not-allowed opacity-50"
              : "cursor-pointer"
          }
        `}
      >
        <input
          id={id}
          name={name}
          type="file"
          accept="image/*"
          required={required && !preview}
          disabled={disabled}
          onChange={handleChange}
          className="sr-only"
        />

        <span
          className="
            absolute left-3 top-0 z-10
            -translate-y-1/2
            bg-white px-1
            text-xs text-gray-500
          "
        >
          {label}
          {required && <span className="text-red-500"> *</span>}
        </span>

        {preview ? (
          <img
            src={preview}
            alt={`${label} preview`}
            className="h-full w-full object-contain p-2 hover:opacity-80"
          />
        ) : (
          <span
            className={`
              px-4 text-center text-base text-gray-400
              transition-transform duration-200
              ${disabled ? "" : "group-hover:scale-105"}
            `}
          >
            Choose an image
          </span>
        )}
      </label>

      {error && (
        <p className="mt-1 text-xs text-red-500">
          {error}
        </p>
      )}

      {children}
    </div>
  );
}